export const info = [
  {
    id: 1,
    title: "Hi,",
    subtitle: "My name is Natthawut Thippasoet. You can call me TOEI.",
    description1:
      "I'm a front-end developer located in Thailand. I love to create simple yet beautiful websites with great user experience.",
    description2:
      "I'm interested in the whole frontend stack Like trying new things and building great projects.I'm an independent freelancer. I love singing and travelling.",
    description3:
      "I believe everything is an Art when you put your consciousness in it. You can connect with me via social links.",
  },
];

export const info2 = [
  {
    id: 1,
    title: "EDUCATION",
    Img1: "https://sv1.picz.in.th/images/2022/02/18/rwit50.png",
    years: "2010-2016",
    grade: "HIGH SCHOOL",
    school: "Phatthalung School, Phatthalung",
    Img2: " https://www.img.in.th/images/1ef1c4300c80501d20ba30c9930e0665.png",
    years2: "2013",
    grade2: "PRE-CADET",
    school2: "Daonairoi School, Songkla",
  },
  {
    id: 2,
    title: "EDUCATION",
    Img1: "https://www.img.in.th/images/132dcddb7a9cdc1dc2b9c011e924b7fa.png",
    years: "2016-2021",
    grade: "COMPUTER ENGINEERING",
    school:
      "Faculty of Engineering, Price Of Songkla University, Phuket Campus.",
  },
];
